import { css } from 'styled-components';
import { borderRadiusStandard, borderRadiusSmall, borderRadiusFull, borderRadiusNone } from '@nib-components/theme';
import { map } from '../../breakpoint';
const mapStringToSelector = string => {
  switch (string) {
    case 'none':
      return borderRadiusNone;
    case 'small':
      return borderRadiusSmall;
    case 'standard':
      return borderRadiusStandard || '4px';
    case 'full':
      return borderRadiusFull;
  }
};
export const borderRadius = () => css`
  ${_ref => {
  let {
    borderRadius
  } = _ref;
  return map(borderRadius, val => val !== undefined && css`
          border-radius: ${mapStringToSelector(val)};
        `);
}};
`;